interface DashboardHeaderProps {
  title: string
  children?: React.ReactNode
}

export default function DashboardHeader({ title, children }: DashboardHeaderProps) {
  return (
    <div className="px-4 pt-8 pb-4 sm:pt-12 sm:px-6 md:pt-16 lg:px-8 xl:flex xl:items-center xl:justify-between">
      <div className="flex-1 min-w-0">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900 dark:text-gray-100">
          {title}
        </h1>
        {children}
      </div>
    </div>
  )
}
